import { defineStore } from 'pinia'

import { createMaintenanceAccidentsActions } from './actions'
import { createMaintenanceAccidentsState } from './state'

export const useMaintenanceAccidentsStore = defineStore('maintenanceAccidents', () => {
    const state = createMaintenanceAccidentsState()
    const actions = createMaintenanceAccidentsActions(state)

    return {
        ...state,
        ...actions
    }
})
